import React, { useState } from "react";
import axios from "axios";
import {Form, Button} from 'react-bootstrap'

const RegistrationForm = () => {
  const [fullName, setFullName] = useState("");
  const [className, setClassName] = useState("");
  const [email, setEmail] = useState("")
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccessMessage("");

    if (!fullName || !className || !email) {
      setError("Please fill in all fields.");
      return;
    }

    const postURL = 'https://cocmgbknd-43a11ed50cba.herokuapp.com/register'

    try {
      const response = await axios.post(postURL, {
        name: fullName,
        class: className,
        email: email
      });

      setSuccessMessage("Registration successful!");
      setFullName("");
      setClassName("");
      setEmail("");
    } catch (error) {
      console.error("Error registering:", error);
      setError("Registration failed, please try again.");
    }
    window.location.reload(true);
  };

  return (
    <div>
      <h2>Register for a Class</h2>

      {/* Accessibility alerts */}
      {error && (
        <p role="alert" style={{ color: "red" }}>
          {error}
        </p>
      )}
      {successMessage && (
        <p role="alert" style={{ color: "green" }}>
          {successMessage}
        </p>
      )}

      <Form onSubmit={handleSubmit} aria-label="Registration Form">
        <Form.Group>
          <Form.Label htmlFor="fullName">
            Full Name:
          </Form.Label>
          <Form.Control
            type="text"
            id="fullName"
            name="fullName"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
            aria-required="true"
            placeholder="Enter your full name"
            aria-describedby="nameHelp"
          />
        </Form.Group>

        <Form.Group className="mt-2">
          <Form.Label htmlFor="className">
            Class: 
          </Form.Label>
          <br/>
          <select
            id="className"
            className="selectDropdown"
            name="className"
            value={className}
            onChange={(e) => setClassName(e.target.value)}
            required
            aria-required="true"
            aria-describedby="classHelp"
          >
            <option value="">Select a class</option>
            <option value="A Class">A Class</option>
            <option value="B Class">B Class</option>
            <option value="Novice">Novice</option>
            <option value="Mens Masters">Mens Masters</option>
            <option value="Womens">Womens</option>
            <option value="lightweight">Lightweight</option>
          </select>
          <Form.Text id="classHelp">Choose your competition class</Form.Text>
        </Form.Group>

        <Form.Group>
          <Form.Label htmlFor="email">
            Email Address:
          </Form.Label>
          <Form.Control
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            aria-required="true"
            placeholder="Enter your email address"
            aria-describedby="emailHelp"
          />
        </Form.Group>


        <Button type="submit" variant="primary" className="mt-2">Register</Button>
      </Form>
    </div>
  );
};

export default RegistrationForm;
